<template>
    <main id="js-page-content" class="webhooks-v2" role="main" v-if="!loading && company">
        <portal to="ariane">
            <div class="tbv2-page-title">{{ $t('menu.companies.webhooks') }}</div>
        </portal>

        <header class="webhooks-hero">
            <h1 class="webhooks-hero-title">{{ $t('menu.companies.webhooks') }}</h1>
            <p class="webhooks-hero-sub">{{ subtitleLabel }}</p>
        </header>

        <section class="webhooks-card">
            <Webhooks v-if="company.webhooks" :webhooks="company.webhooks" />
        </section>
    </main>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import Webhooks from '@/components/Model/Company/Webhooks'
import { mapActions, mapState } from 'vuex'

export default {
    name: 'CompanyWebhooks',
    components: {
        Webhooks
    },
    data() {
        return {
            loading: true
        }
    },
    created() {
        this.getMyCompany().then(() => {
            this.loading = false
        })
    },
    computed: {
        ...mapState('company', {
            company: (state) => state.company
        }),
        webhookCount() {
            if (!this.company || !Array.isArray(this.company.webhooks)) return 0
            return this.company.webhooks.length
        },
        subtitleLabel() {
            if (this.webhookCount === 0) {
                return this.$t('menu.companies.webhooks_empty')
            }
            const formatted = new Intl.NumberFormat(this.$i18n.locale).format(this.webhookCount)
            const key = this.webhookCount === 1
                ? 'menu.companies.webhooks_count_one'
                : 'menu.companies.webhooks_count_other'
            return this.$t(key, { count: formatted })
        }
    },
    methods: {
        ...mapActions('company', ['getMyCompany'])
    }
}
</script>

<style scoped>
.webhooks-v2 {
    width: 100%;
    padding: 24px 32px 48px;
    font-family: var(--v2-font-sans);
    color: var(--v2-text-2);
}

.tbv2-page-title {
    font-size: 0.95rem;
    font-weight: var(--v2-font-weight-semibold);
    color: var(--v2-text-1);
    letter-spacing: -0.005em;
}

.webhooks-hero {
    margin-bottom: var(--v2-space-5);
}

.webhooks-hero-title {
    margin: 0 0 6px;
    font-size: 1.75rem;
    font-weight: var(--v2-font-weight-bold);
    color: var(--v2-text-1);
    letter-spacing: -0.02em;
    line-height: 1.15;
}

.webhooks-hero-sub {
    margin: 0;
    font-size: var(--v2-text-sm-size);
    color: var(--v2-text-3);
    line-height: 1.5;
}

.webhooks-card {
    background: var(--v2-surface-0);
    border: 1px solid var(--v2-border);
    border-radius: var(--v2-radius-lg);
    overflow: hidden;
}

@media (max-width: 900px) {
    .webhooks-v2 {
        padding: 16px 18px 32px;
    }

    .webhooks-hero-title {
        font-size: 1.375rem;
    }
}
</style>
